import { TEDCustomDateTimeParser } from './TEDCustomDateTimeParser';
import { TEDParseDateTimeMode } from '../FormatterTypes';

export class TEDParseTimeHour extends TEDCustomDateTimeParser {
  public static getInstance(): TEDParseTimeHour {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDParseTimeHour;

  public mode() {
    return TEDParseDateTimeMode.pdmH;
  }
}
